import { Directive } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { getPersonalData } from '../../+state';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ImmomioIconName } from '../../models';

@UntilDestroy()
@Directive()
export class CooperativeInformationBaseComponent {
  public cooperativeData$ = this.store
    .select(getPersonalData)
    .pipe(map(personalData => personalData?.cooperativeData));
  public immomioIconName = ImmomioIconName;

  constructor(private store: Store) {}
}
